import { useDispatch } from "react-redux";
import React, { useEffect } from "react";
import { modalTypes } from "constants/types";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import {
  downloadWorkbook,
  uploadWorkbook,
} from "slices/settings/actions/excelOutput";
import { showModal } from "slices/app/actions/modals";
import { setActiveTab } from "slices/settings/slices/activeTabSlice";
import { TooltipTrigger } from "@visiblethread/react-components/dist/components/Tooltip";

const tooltipText =
  "For exports, you can embed macros in the Excel files we generate. Use this to customize Excel Reports after generation.";

const ExcelOutputCustomization = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveTab(5));
  }, [dispatch]);

  const handleDownload = (template) => {
    dispatch(downloadWorkbook(template));
  };

  const handleUpload = () => {
    dispatch(
      showModal(modalTypes.IMPORT_FILE, {
        title: "Upload Macros",
        accepts: ".xlsm",
        okText: "Upload",
        onOk: (formData) => {
          dispatch(uploadWorkbook(formData));
        },
      })
    );
  };

  return (
    <div className="excel_output">
      <div className="excel_output__header">
        <h1>Excel Output Customization</h1>
        <TooltipTrigger content={tooltipText}>
          <div
            className="readability_thresholds__header__info_icon"
            aria-label="information tooltip icon"
          >
            i
          </div>
        </TooltipTrigger>
      </div>
      <div className="excel_output__content">
        <p>
          For exports, you can embed macros in the Excel files we generate. Use
          this to customize Excel Reports after generation.
        </p>
        <p>To add or edit macros:</p>
        <ol>
          <li>
            Click &apos;Download Workbook&apos; to download the current macro
            template for editing.
          </li>
          <li>Open the file in Excel and press &apos;Alt+F8&apos;</li>
          <li>Add or edit macros. Then save the File.</li>
          <li>
            Click &apos; Workbook&apos; update your environment with the new
            workbook.
          </li>
        </ol>
        <p>
          Need to get back to the original default Workbook? No worries, you can
          get it{" "}
          <button type="button" onClick={() => handleDownload(true)}>
            here
          </button>
        </p>
      </div>
      <div className="excel_output__buttons">
        <Button
          onClick={() => handleDownload(false)}
          variant={buttonVariants.primary}
          content="Download Workbook"
        />
        <Button
          onClick={handleUpload}
          variant={buttonVariants.secondary}
          content="Upload Workbook"
        />
      </div>
    </div>
  );
};

export default ExcelOutputCustomization;
